module.exports = __webpack_public_path__ + "static/img/Luke-Thompson.c325c0d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Luke-Thompson.jpg
// module id = 8W4f
// module chunks = 0